import { RegisterItemContentVariant } from '@modules/registers/items/types'
import { RegisterItemText } from '@modules/registers/items/RegisterItemText'
import { RegisterItemContentButtons } from '@modules/registers/propertyValue/RegisterItemPropertyValueButtons'
import moment from 'moment/moment'
import { emptyValue } from '@modules/registers/propertyValue/helpers'
import { RegisterItemTimeProperty } from '@core/entities/register/RegisterItem'

type RegisterItemPropertyTimeValueProps = {
  registerItemPropertyData: RegisterItemTimeProperty<string>
  variant?: RegisterItemContentVariant
}

export const RegisterItemPropertyTimeValue: React.FC<
  RegisterItemPropertyTimeValueProps
> = ({ registerItemPropertyData, variant }) => {
  const displayString = registerItemPropertyData?.timeValue
    ? // Dates are stored as UTC datetime, we do not want to convert them to the user's local time
      moment
        .utc(
          `${moment().format('YYYY-MM-DD')} ${
            registerItemPropertyData?.timeValue
          }`,
        )
        .format('HH:mm')
    : emptyValue(variant)

  const inner = <RegisterItemText>{displayString}</RegisterItemText>

  if (variant === 'table') {
    return inner
  }

  return (
    <RegisterItemContentButtons
      variant={variant}
      value={displayString}
      registerItemPropertyData={registerItemPropertyData}
    >
      {inner}
    </RegisterItemContentButtons>
  )
}
